import { combineReducers } from "@reduxjs/toolkit";
import mjpApi from "../apis/manageJobPostingHooks";
import loginApi from "../apis/login";
import downloadSlice from "./downloadSlice/downloadSlice";
import loginSlice from './loginSlice'
import fmSlice from "./fmSlice/fmSlice";
const rootReducer = combineReducers({
  // add reducers here ...
  [mjpApi.reducerPath]: mjpApi.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
  [downloadSlice.name]:downloadSlice.reducer,
  [loginSlice.name]:loginSlice.reducer,
  [fmSlice.name]:fmSlice.reducer
});

// export const reduxMiddlewares = [
//     // add middlewares here ...
//     dashboardApi.middleware,
//     folderManagementApi.middleware,
//     manageSaveSearchApi.middleware,
//     loginApi.middleware,
//     masterDataApi.middleware,
// ]

export default rootReducer;
